import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { LoadingScreen } from "./LoadingIndicator";
import { useAuth } from "../contexts/AuthContext";
import { isAdmin } from "../utils/roleUtils";

export default function PublicRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  const allowWhenAuthenticated =
    location.pathname === "/reset-password" || location.pathname === "/verify-email";

  if (loading) {
    return <LoadingScreen message="Loading your session..." />;
  }

  if (user && !allowWhenAuthenticated) {
    return <Navigate to={adminOnly && isAdmin(user) ? "/admin/dashboard" : "/dashboard"} replace />;
  }

  return children;
}
